module.exports = __webpack_public_path__ + "static/media/faq_bg.700ece88.svg";